import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Col } from 'react-bootstrap'
import { getScormBlock } from 'api/lessons/block-instances/GetScormBlock'
import Loader from 'components/ui/loader/Loader'
import { BlockScormContent } from 'store/states/lessons.state'
import Scorm from '../courses/lessons/components/LessonCard/components/ContentBlock/components/Scorm'
import styles from './ScormPage.module.scss'

export const ScormPage = () => {
  const { id } = useParams<{ id: string }>()
  const [loading, setLoading] = useState(true)
  const [blockScorm, setBlockScorm] = useState<BlockScormContent>()

  useEffect(() => {
    getScormBlock(+id)
      .then((res) => {
        setBlockScorm(res)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [id])

  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [])

  if (loading)
    return (
      <Col>
        <div className="d-flex justify-content-center">
          <Loader color />
        </div>
      </Col>
    )
  if (!blockScorm) return null
  return (
    <div className={styles.fullscreenPage}>
      <Scorm data={blockScorm} buttons={false} canCloseWindow />
    </div>
  )
}

export default ScormPage
